import { Flex, Input, Label, Span, Range } from '@fareye/ui'
import {
  ddMMMMYYYY,
  hhmmADoMMMYYYY,
  hhmmA,
  isEmpty,
  removeAlertSubText,
  ordinals
} from '@fareye/utils'

import React from 'react'
import { escalation, labelColor } from '../../../utility/colors'
import { tripDetailConstant } from '../../../utility/constants'
interface IExceptionsListing {
  data: any
  dataLength: number
  onSelect: (id: any) => void
  id: { [key: string]: any }
  exceptionSlider: any
  currExceptionSlider: any
  setCurrExceptionSlider: any
}

export const ExceptionsListing = ({
  id,
  data,
  dataLength,
  onSelect,
  exceptionSlider,
  currExceptionSlider,
  setCurrExceptionSlider
}: IExceptionsListing) => {
  const [exceptionValue, setExceptionValue] = React.useState({
    min: currExceptionSlider.min,
    max: currExceptionSlider.max
  })

  React.useEffect(() => {
    setExceptionValue({
      min: currExceptionSlider.min,
      max: currExceptionSlider.max
    })
  }, [currExceptionSlider])

  return (
    <React.Fragment>
      {dataLength > 0 && (
        <Flex p={2} column style={{ overflow: 'hidden' }}>
          <Label variant={'h6'} style={{ fontWeight: 700 }}>
            {tripDetailConstant.exceptions}
          </Label>
          {dataLength > 1 && (
            <Range
              formatLabel={(value: any) => hhmmADoMMMYYYY(value)}
              maxValue={exceptionSlider.max}
              minValue={exceptionSlider.min}
              value={exceptionValue}
              onChange={(value: any) => {
                setExceptionValue(value)
              }}
              onChangeComplete={(value: any) => setCurrExceptionSlider(value)}
            />
          )}
        </Flex>
      )}
      {!isEmpty(data) ? (
        data.map((item: any, index: number) => (
          <Flex key={index} style={{ marginBottom: '20px' }} p={2}>
            <Input
              type="radio"
              checked={item.id === id.exceptionId}
              onChange={() => {
                onSelect({ exceptionId: item.id })
              }}
            />
            <Flex column style={{ width: '40%' }}>
              <Span
                variant={'ellipsis'}
                color={labelColor.normalText}
                style={{ fontWeight: 700 }}
              >
                {removeAlertSubText(item.type)}
              </Span>
              {item.escalation && (
                <Label
                  variant="h6 s"
                  style={{
                    backgroundColor: `${
                      escalation[item.escalation > 3 ? 3 : item.escalation]
                    }`,
                    borderRadius: '20px',
                    marginRight: 'auto',
                    padding: '2px 6px 2px 6px'
                  }}
                >{`${ordinals(item.escalation)} Escalation`}</Label>
              )}
            </Flex>
            <Flex column style={{ width: '30%' }}>
              <Span>{hhmmA(item.createdAt)}</Span>
              <Span>{ddMMMMYYYY(item.createdAt)}</Span>
            </Flex>
            <Flex column>
              {item.isClosed ? (
                <Span color={labelColor.normalText}>
                  {tripDetailConstant.isClosed}
                </Span>
              ) : (
                <>
                  {
                    // resolution timer hidden to be implemented from config if needed
                    /* <CountDownTimer
                      reference={item.createdAt}
                      textStyle={{ fontSize: '1.2em', color: labelColor.alert }}
                    /> */
                  }
                  <Span color={labelColor.normalText}>
                    {tripDetailConstant.awaitingResolution}
                  </Span>
                </>
              )}
            </Flex>
          </Flex>
        ))
      ) : (
        <Label
          style={{
            width: '100%',
            paddingTop: '10vmax',
            textAlign: 'center',
            display: 'block'
          }}
        >
          No Data
        </Label>
      )}
    </React.Fragment>
  )
}
